import { useState,useEffect } from 'react'
import { get, post } from '../../utils/axios'
import { Alert, Box, Fade, Grid, Modal, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { toast } from 'react-toastify'

const Favorits = () => {

    const [isLoading,setIsLoading] = useState(true)
    const [open,setOpen] = useState(false)
    const [notifications,setNotifications] = useState([])
    const [currentMessage,setCurrentMessage] = useState('')
    const [currentTitle,setCurrentTitle] = useState('')
    const [favorites,setFavorites] = useState([])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };

    useEffect(() => {
        post('Anoncement/GetFavoriteAnoncement').then(({ data }) => {
            if(data.isSuccess)
                setFavorites(data.data.id)
        })
        get('Anoncement/GetAnoncement').then(({ data }) => {
            if(data.isSuccess)
                setNotifications(data.data)
        }).finally(() => {
            setIsLoading(false)
        })
    },[])

    const openNotificationModal = notification => {
        setCurrentTitle(notification.title)
        setCurrentMessage(notification.content)
        setOpen(true)
    }

    const shareNotification = notification => {
        if(navigator.share)
            navigator.share({
                title: notification.title,
                text: notification.title + '\r\n' + notification.content
            })
        else
            toast.warning('این عملیات فقط در موبایل امکان پذیر است')
    }

    const removeFromFavorite = notification => {
        const postedData = {
            id: notification.id
        }
        post('Anoncement/RemoveFavoriteAnoncement',postedData).then(({ data }) => {
            if(data.isSuccess){
                setFavorites(data.data.id)
                toast.success('از لیست علاقه مندی ها حذف شد')
            }
        })
    }

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">اطلاعیه های محبوب</h3>
            <div className="safe-area">
                <div id="notification-box">
                    {isLoading ? <div style={{display: 'table',margin: '20px auto'}}><CircularProgress size={24} /></div> : (notifications.filter(notification => favorites.includes(notification.id)).length ? notifications.filter(notification => favorites.includes(notification.id)).map(notification => <div key={notification.id} className="notification-content">
                        <h3><i className="fal fa-pen"></i>{notification.title}</h3>
                        <i className="fal fa-share-nodes share-notification-button" onClick={() => shareNotification(notification)}></i>
                        {<i className="fas fa-heart add-to-favorite-notification-button" onClick={() => removeFromFavorite(notification)}></i>}
                        <p>{notification.content.slice(0,70)} ...</p>
                        <button className="read-notification" onClick={() => openNotificationModal(notification)}>ادامه خواندن</button>
                    </div>) : <Alert severity="info" className="custom-alert" sx={{my: 1}}>شما اطلاعیه مورد علاقه ندارید</Alert>)}
                    <Modal open={open} onClose={() => setOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Fade in={open}>
                            <Box sx={style}>
                                <Typography variant="h6" component="h2">{currentTitle}</Typography>
                                <Typography sx={{ mt: 2,textAlign: 'justify' }}>{currentMessage}</Typography>
                            </Box>
                        </Fade>
                    </Modal>
                </div>
            </div>
        </Grid>
    )
}

export default Favorits